import { render, staticRenderFns } from "./tunnel-editor.vue?vue&type=template&id=476a8be8"
import script from "./tunnel-editor.vue?vue&type=script&lang=ts"
export * from "./tunnel-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports